import React, { useEffect } from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import AppAppBar from '../../components/layout/AppAppBar';
import congratulationsGif from '../../assets/Congratulations_20260102065157.gif';
import downloadApkGif from '../../assets/downlaod_APK.gif';

// Add global definition
declare global {
  interface Window {
    gtag: (
      cmd: string,
      action: string,
      params?: {
        event_category?: string;
        event_label?: string;
        page_location?: string;
        [key: string]: any;
      }
    ) => void;
  }
}

export default function PaymentSuccessPageReject() {
  const isLoggedIn = !!(localStorage.getItem('user_data') || localStorage.getItem('profile') || localStorage.getItem('is_logged_in'));

  useEffect(() => {
    // Check if user is from reject flow
    const formName = localStorage.getItem('current_form_name');
    const isRejectFlow = formName && formName.toLowerCase().includes('reject');

    if (!isRejectFlow) {
      console.warn('Unauthorized access to Reject payment success page. Redirecting...');
      window.location.href = '/';
      return;
    }

    // Check if the user reached this page through the processing page
    const isProcessed = sessionStorage.getItem('payment_processed');
    if (!isProcessed) {
      window.location.href = '/';
    }
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fff' }}>
      {/* Common Navbar */}
      <AppAppBar mode="light" toggleColorMode={() => { }} simpleNavbar={true} transparentMode={true} showProfile={isLoggedIn} showLogin={false} />

      <Container sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: 'calc(100vh - 60px)', bgcolor: '#fff', pt: 11 }}>
        <Typography
          variant="h4"
          sx={{
            mb: 4,
            fontWeight: 800,
            fontFamily: 'General-Sans-bold',
            color: '#000',
            position: 'relative',
            display: 'inline-block',
            zIndex: 1
          }}
        >
          Payment Successful
          <Box
            sx={{
              position: 'absolute',
              bottom: '6px',
              right: '-5px',
              width: '60%',
              height: '10px',
              bgcolor: '#FFD700',
              borderRadius: '2px',
              zIndex: -1
            }}
          />
        </Typography>

        <Box
          sx={{
            width: '200px',
            height: '200px',
            mb: 3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img
            src={congratulationsGif}
            alt="Congratulations"
            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          />
        </Box>

        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            color: '#333',
            textAlign: 'center',
            mb: 2,
            fontFamily: 'SF Pro Display',
            fontSize: '18px'
          }}
        >
          Great! Your payment is confirmed.
        </Typography>

        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            color: '#757575',
            maxWidth: 320,
            mb: 5,
            fontSize: '14px',
            fontWeight: 500,
            fontFamily: 'SF Pro Display'
          }}
        >
          <>
            Note: Wait for 24 hours to recieve your payment.
          </>
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mb: 2,
            fontWeight: 600,
            color: '#000',
            fontFamily: 'SF Pro Display'
          }}
        >
          Want To Earn More Money ?
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={() => {
            // 1. Manual GA4 tracking as requested
            if ((window as any).gtag) {
              (window as any).gtag("event", "download_apk_click", {
                event_category: "engagement",
                event_label: "payment_success_reject_page",
                page_location: window.location.href,
              });
            } else {
              // Fallback if gtag not ready (optional, but good practice)
              console.warn("GTM/GA4 not loaded");
            }

            // 2. Navigation / Download Logic
            window.location.href = "https://offer.app20.in/apk";
          }}
          sx={{
            background: 'linear-gradient(180deg, #FFECB3 0%, #FFC107 100%)',
            color: '#000',
            py: 1,
            px: 2,
            borderRadius: '16px',
            maxWidth: 335,
            textTransform: 'none',
            boxShadow: '0 8px 20px rgba(255, 193, 7, 0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0,
            '&:hover': {
              background: 'linear-gradient(180deg, #FFE082 0%, #FFB300 100%)',
              boxShadow: '0 10px 24px rgba(255, 193, 7, 0.4)',
            }
          }}
        >
          <Box
            sx={{
              width: '66px',
              height: '66px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={downloadApkGif}
              alt="Download"
              style={{ width: '66px', height: '66px', objectFit: 'contain' }}
            />
          </Box>
        </Button>
      </Container>
    </Box>
  );
}
